<template>
    <base-tippy
        class="mx-0.5 self-center"
        content="Informations complètes"
        placement="bottom-end"
    >
        <base-icon
            class="text-green-500"
            icon="check"
            size="sm"
        ></base-icon>
    </base-tippy>
</template>

<script>
import BaseIcon from '../Base/BaseIcon'
import BaseTippy from '../Base/BaseTippy'

export default {
  name: 'InformationsValidAndFull',
  components: {
    BaseTippy,
    BaseIcon
  }
}
</script>

<style scoped>

</style>
